import React, { useContext } from "react";
import "./About.css";
import Card from "../Card/Card";
import HeartEmoji from "../../img/heartemoji.png";
import Glasses from "../../img/glasses.png";
import Humble from "../../img/humble.png";
import { themeContext } from "../../Context";
import { motion } from "framer-motion";



const About = () => {

  const links=[
    {
    
      href : "https://github.com/23121991/node-hallbooking",
    },
    {
      href: "https://github.com/23121991/node-hallbooking",
    },
    {
      href : "https://github.com/23121991/node-hallbooking",
    }
    
    
      ]

  // context
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;


  // transition
  const transition = {
    duration: 1,
    type: "spring",
  };

  return (
    <div className="services" id="services">
      {/* left side */}
      <div className="awesome">
        {/* dark mode */}
        <span style={{ color: darkMode ? "white" : "" }}>
        Educational</span>
        <span>Qualifications</span>
        <spane>
         <span>B.E</span> (Electrical & Electronics Engineering)
          <br />
          <span>M.B.A</span> (Human Resources Management)
        </spane>
        <a href='https://drive.google.com/file/d/1dCuDwypBrylC4VL3PC3EMdPIOgfQtgLf/view?usp=drive_link'
        target="_Blank" rel="noopener noreferrer">
                    <button className="button s-button" >View Cv</button>
                </a>
        <div className="blur s-blur1" style={{ background: "#ABF1FF94" }}></div>
      </div>
      {/* right */}
      <div className="cards">
        {/* first card */}
        <motion.div
          initial={{ left: "25rem" }}
          whileInView={{ left: "14rem" }}
          transition={transition}
        >
          <Card
            emoji={HeartEmoji}
            heading={"Front End Languages"}
            detail={"Reactjs, Html, Css, JavaScript,"}
          />
        </motion.div>
        {/* second card */}
        <motion.div
          initial={{ left: "-11rem", top: "12rem" }}
          whileInView={{ left: "-4rem" }}
          transition={transition}
        >
          <Card
            emoji={Glasses}
            heading={"BackEnd Languages"}
            detail={"NodeJs, ExpressJs "}
          />
        </motion.div>
        {/* 3rd */}
        <motion.div
          initial={{ top: "19rem", left: "25rem" }}
          whileInView={{ left: "12rem" }}
          transition={transition}
        > 
             
          <Card
            emoji={Humble}
            heading={"DataBase"}
            detail={
              "MySql, MongoDb "
            }
            color="rgba(252, 166, 31, 0.45)"
          />
          {links.map((item,index) => ( <a href ={item.href}>{index[0]}

      </a>
      ))}
        </motion.div>
        <div
          className="blur s-blur2"
          style={{ background: "var(--purple)" }}
        ></div>
      </div>
    </div>
  );
};

export default About;
